import { get } from '../..';
import { Metric } from '../../../constants/Types';
import { DateRange } from '../../../redux/dateRangeSlice';
import { AggregationFunction } from '../GetMetric';

interface GetAverageUtilizationProps {
  range: DateRange,
  parentLocationId: string,
}

const GetAverageUtilization = ({ range, parentLocationId }: GetAverageUtilizationProps) => {
  let query: string = 'metrics/per-sublocation';
  query += `?parentLocationId=${parentLocationId}&from=${range.start}&to=${range.end}&metric=${Metric.UTILIZATION}&aggregationFunction=${AggregationFunction.MAX}`;
  return get(query);
};

export default GetAverageUtilization;
